import { Controller, useWatch } from "react-hook-form";
import Box from "@mui/material/Box";
import { PRE_ACTIVATION_OTHER_OPTION_VALUE } from "../agencyFormConfig";
import CheckGroup from "./CheckGroup";
import FieldBlock from "./FieldBlock";
import FieldError from "./FieldError";
import FieldHint from "./FieldHint";
import FieldLabel from "./FieldLabel";
import TextFieldBlock from "./TextFieldBlock";
import { getVisibleFieldErrorMessage } from "../preActivationVisibleErrors";

const CheckGroupWithOtherField = ({
  name,
  otherName,
  otherPlaceholder,
  otherValue = PRE_ACTIVATION_OTHER_OPTION_VALUE,
  label,
  hint,
  required = false,
  options = [],
  control,
  errors,
  readOnly,
}) => {
  const value = useWatch({ control, name });
  const showOther = Array.isArray(value) && value.includes(otherValue);

  return (
    <FieldBlock>
      <FieldLabel htmlFor={name} text={label} required={required} />
      {hint ? <FieldHint text={hint} /> : null}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState, formState }) => (
          <>
            <CheckGroup
              name={name}
              options={options}
              selectedValues={field.value}
              onChange={field.onChange}
              readOnly={readOnly}
            />
            <FieldError
              message={getVisibleFieldErrorMessage(fieldState, formState)}
            />
          </>
        )}
      />
      {showOther ? (
        <Box sx={{ mt: 1.5 }}>
          <TextFieldBlock
            name={otherName}
            label={otherPlaceholder}
            placeholder={otherPlaceholder}
            showLabel={false}
            control={control}
            errors={errors}
            readOnly={readOnly}
          />
        </Box>
      ) : null}
    </FieldBlock>
  );
};

export default CheckGroupWithOtherField;
